'use client';

import dynamic from 'next/dynamic';

// Payment icons (~22.5KB of inline SVG path data) are below the fold on every
// page and not required for LCP. Load them as a single client-only chunk so
// they never appear in the SSR / RSC payload. The skeleton reserves the exact
// dimensions of the rendered icons to prevent layout shift on hydration.
const PaymentIconsGroup = dynamic(() => import('./payment-icons-group'), {
  ssr: false,
  loading: () => <PaymentIconsSkeleton />,
});

function PaymentIconsSkeleton() {
  // Dimensions must match the rendered icons (24×24, see payment icon SVGs
  // which all use viewBox="0 0 24 24" and width/height 24) so the final
  // layout is identical and hydration causes no shift.
  return (
    <>
      {Array.from({ length: 6 }).map((_, idx) => (
        <div
          aria-hidden
          className="h-6 w-6 rounded bg-[hsl(var(--contrast-100))]/40"
          key={idx}
        />
      ))}
    </>
  );
}

export function PaymentIconsLazy() {
  return <PaymentIconsGroup />;
}
